export default __webpack_public_path__ + "static/media/placeholder_dummy2016-schneiderei01-de.1458bcb9.png";